import { render, staticRenderFns } from "./clientCase.vue?vue&type=template&id=3d618bf6&scoped=true&"
import script from "./clientCase.vue?vue&type=script&lang=js&"
export * from "./clientCase.vue?vue&type=script&lang=js&"
import style0 from "./clientCase.vue?vue&type=style&index=0&id=3d618bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d618bf6",
  null
  
)

export default component.exports